import { useMutation, useQuery } from "@tanstack/react-query";
import client from "./config"; // Assuming this is your Axios instance

const fetchPaymentsByUser = async (UserID) => {
    if (!UserID) throw new Error("UserID is required");

    const response = await client.get(`/api/getallpayments/${UserID}`);
    return response.data.data;
};

const useFetchPaymentsByUser = (userId) => {
    return useQuery({
        queryKey: ['PaymentsByUser', userId],
        queryFn: () => fetchPaymentsByUser(userId),
        enabled: !!userId, // only fetch when both values are available
    });
};

const useHandleSubscription = () => {
  return useMutation(async ({ subscriptionId, cancelAtPeriodEnd }) => {
    const res = await client.post("/api/handle-subscription", {
      subscriptionId,
      cancelAtPeriodEnd,
    });
    return res.data;
  });
};

const useToggleAutoRenew = () => {
  return useMutation(async ({ subscriptionId, autoRenew }) => {
    const res = await client.post("/api/toggle-auto-renew", {
      subscriptionId,
      autoRenew,
    });
    return res.data;
  });
};

const useFetchSubscriptionPlans = () => {
    return useQuery(['subscriptionPlans'], async () => {
        const { data } = await client.get('/api/subscription-plans');
        return data;
    });
};

const useFetchLocalizedPlans = (userId, countryCode) => {
  return useQuery({
    queryKey: ['subscriptionPlansLocalized', userId, countryCode],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (userId) params.append('UserID', userId);
      if (countryCode) params.append('countryCode', countryCode);
      const { data } = await client.get(`/api/subscription-plans-localized?${params.toString()}`);
      return data; // { region, currency, pricing: { monthly, yearly }, priceIds: { monthly, yearly } }
    },
    enabled: !!userId || !!countryCode,
  });
};

export { useFetchPaymentsByUser, useHandleSubscription, useToggleAutoRenew, useFetchSubscriptionPlans, useFetchLocalizedPlans }